import { BuildingProductTypeView, ProductTypeView } from '@api-proxies';
import { ProductTypeService } from '@http/clients/product-type.service';
import { ProductTypeEntity } from './abstract/product-type-entity';

export class BuildingProductTypeEntity extends ProductTypeEntity<BuildingProductTypeView> {
    constructor(productTypeService: ProductTypeService) {
        super(productTypeService);
    }

    toDestination(entity: ProductTypeView): BuildingProductTypeView {
        return { id: 0, productTypeId: entity.id, productTypeName: entity.name, isActive: entity.isActive };
    }

    toSource(entity: BuildingProductTypeView): ProductTypeView {
        return {
            id: entity.productTypeId,
            name: entity.productTypeName,
            isActive: entity.isActive ?? true,
            order: 1,
            isReserved: true
        };
    }
}
